import { BaseController } from '../../../../../../../common/base/controller';
import { MODEL_FIELDS } from '../../createRequest.model';

export class DispatchAddressController extends BaseController {
  constructor($scope, $compile, controllerService) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
    });
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;
    this.model[this.MODEL_FIELDS.dispatchAddressCountry] =
      this.envService.countryCode || 'DE';

    this.countryOptions = {
      modelKey: 'key',
      orderKeys: false,
      searchEnabled: false,
      selectables: [
        { key: 'DE', value: 'app.card.section.address.country.DE' },
        { key: 'AT', value: 'app.card.section.address.country.AT' },
        { key: 'CH', value: 'app.card.section.address.country.CH' },
      ],
    };
  }
}
